import popImg from "../assets/img/pop.jpeg";
import menagerieImg from "../assets/img/menagerie.jpeg";
import kensingtonImg from "../assets/img/kensington.jpeg";
import schwerinImg from "../assets/img/schwerin.jpeg";
import harwoodImg from "../assets/img/harwood.png";
import eurostarImg from "../assets/img/eurostar.jpeg";
import courtyardImg from "../assets/img/courtyard.jpeg";
import beauxImg from "../assets/img/beauxarts.png";
import alanisImg from "../assets/img/alanis.png";
import hamburgstationImg from "../assets/img/hamburgstation.jpg";
import hamptonImg from "../assets/img/hampton.jpeg";
import stpancrasImg from "../assets/img/stpancras.jpeg";
import heathrowImg from "../assets/img/lhr.png";
import baseImg from "../assets/img/basejump.png";
import dandoyImg from "../assets/img/dandoy.jpeg";
import zuidImg from "../assets/img/zuid.jpeg";
import hamburgerImg from "../assets/img/hamburger.jpeg";
import lucImg from "../assets/img/luc.png";
import autobahnImg from "../assets/img/autobahn.jpeg";
import ritterImg from "../assets/img/ritter.png";
import berghainImg from "../assets/img/berghain.jpg";
import museumsinselImg from "../assets/img/museumsinsel.jpg";
import hiltonImg from "../assets/img/hilton.png";
import gayBerlinImg from "../assets/img/gayBerlin.webp";
import antinoosImg from '../assets/img/antinoos.jpeg';
import lufthansaImg from '../assets/img/lufthansa.jpeg';


export const EVENTS = [
  {
    id: 110740,
    name: "Arrive at London Heathrow Airport via Newark-Liberty",
    city: "London",
    place: "London - Heathrow Airport",
    date: 11,
    time: "11:30am",
    link: "https://www.heathrow.com/",
    image: heathrowImg,
    day: "Saturday",
    address: "Longford TW6, United Kingdom",
    description:
      "Arrive at London-Heathrow Airport via United Airlines Flight 146",
    cost: 220,
  },
  {
    id: 111200,
    name: "Harwood Arms",
    place: "Fulham",
    city: "London",
    date: 11,
    day: "Saturday",
    image: harwoodImg,
    address: "Walham Grove, London SW6 1QP, United Kingdom",
    description: "Sunday Roast, on Saturday? Fuck you. Have a Michelin star.",
    confirmation: "Confirmation: #2109907687",
    time: "12:00pm",
    link: "https://harwoodarms.com/",
  },
  {
    id: 111500,
    name: "Check In - Residence Inn, Kensington",
    place: "Residence Inn London, Kensington",
    date: 11,
    day: "Saturday",
    city: "London",
    time: "3:00pm",
    image: kensingtonImg,
    link: "https://www.marriott.com/en-us/hotels/lonrk-residence-inn-london-kensington/overview/",
    address: "181-183 Warwick Road, London, England, United Kingdom, W14 8PU",
    description: "Take a nap! #jetlag",
    confirmation: "Confirmation: 86579042",
    cost: 64.77,
  },
  {
    id: 111930,
    name: "The Glass Menagerie",
    place: "Duke of York's Theatre, West End",
    date: 11,
    day: "Saturday",
    city: "London",
    time: "7:30pm",
    link: "https://www.theglassmenageriewestend.com/",
    image: menagerieImg,
    address: "St Martin's Ln, London WC2N 4BG, United Kingdom",
    description: "Confirmation 21923592, Stalls D19, D20",
    cost: 243.74,
  },
  {
    id: 112100,
    name: "Pop!",
    place: "The Eagle - London",
    date: 11,
    day: "Saturday",
    city: "London",
    time: "9:00pm-4:00am",
    link: "https://www.eaglelondon.com/event-details/pop-5",
    image: popImg,
    address: "349 Kennington Ln, London SE11 5QY, United Kingdom",
    description: "Dance Party",
    confirmation: "Confirmation: 86579042",
    cost: 64.77,
  },
  {
    id: 151600,
    name: "Going To The Castle",
    place: "Schloss Schwerin",
    date: 15,
    time: "4:00pm",
    city: "Hamburg",
    day: "Wednesday",
    image: schwerinImg,
    address: "Lennéstrasse 1, 19053 Schwerin, Germany",
    description: "Castle",
    confirmation: "Confirmation: 86579042",
    cost: 64.77,
    link: "https://en.wikipedia.org/wiki/Schwerin_Castle",
  },
  {
    id: 121934,
    name: "London St Pancras Int' to Brussels-Midi/Zuid",
    city: "London",
    place: "St. Pancras International",
    image: stpancrasImg,
    address: "Euston Rd, London N1C 4QP, United Kingdom",
    date: 12,
    day: "Sunday",
    description: "Depart for Brussels-Midi",
    link: "https://stpancras.com/",
    time: "7:34pm",
    confirmation: "Confirmation: 4VW4WZ",
  },
  {
    id: 122235,
    name: "Arrive Brussels-Midi/Zuid",
    city: "Brussels",
    image: eurostarImg,
    address: "Avenue Fonsny 47B, 1060 Brussel, Belgium",
    date: 12,
    day: "Sunday",
    description: "Arrive Brussels-Midi",
    link: "https://www.eurostar.com/us-en/travel-info/stations/brussels-midi",
    time: "10:35pm",
  },
  {
    id: 122300,
    name: "Check In Courtyard Brussels",
    city: "Brussels",
    image: courtyardImg,
    place: "EU Quarter",
    address: "Rue Joseph II 32, Brussels, 1000 Belgium",
    date: 12,
    description: "Check In at the Courtyard-Brussels EU Quarter",
    link: "https://www.marriott.com/en-us/hotels/brumt-courtyard-brussels-eu/overview/?scid=554ff96d-1f1d-4761-a71d-dfe66c104af5&gclid=Cj0KCQjwhLKUBhDiARIsAMaTLnEYaG-otfrWCbtUWAHg6xfqsynltDbYI016mFVS-Ot16rTc7JPqT7MaAveuEALw_wcB&gclsrc=aw.ds",
    time: "11:00pm",
    day: "Sunday",
    confirmation: "85671967",
  },
  {
    id: 131030,
    name: "Speculoos City",
    place: "Maison Dandoy, Grand Place",
    city: "Brussels",
    time: "10:30am",
    image: dandoyImg,
    date: 13,
    description: "Breakfast is where they invented Speculoos. nbd.",
    link: "https://maisondandoy.com/",
    day: "Monday",
    address: "Rue au Beurre 31, Brussels 1000 Belgium",
  },
  {
    id: 131130,
    name: "Royal Museums of Fine Arts of Belgium",
    city: "Brussels",
    place: "The Museum of Old Masters",
    date: 13,
    image: beauxImg,
    address: "Rue du Musée 9 / Museumstraat 9 - 1000 Brussels",
    link: "https://www.fine-arts-museum.be/en",
    time: "11:30am",
    day: "Monday",
  },
  {
    id: 140823,
    name: "Depart Brussels-Midi via ICE 13 for Cologne Hbf",
    place: "Brussels Zuid",
    city: "Brussels",
    image: zuidImg,
    address: "Avenue Fonsny 47B, 1060 Brussel, Belgium",
    link: "https://www.eurostar.com/us-en/travel-info/stations/brussels-midi",
    date: 14,
    time: "8:23am",
    description: "European High Speed Rail to Cologne, 1st Class",
    confirmation: "Confirmation: 3O6B16",
    day: "Tuesday",
  },
  {
    id: 141512,
    name: "Arrive Hamburg via IC 2216 from Cologne Hbf",
    city: "Hamburg",
    place: "Hamburg Hauptbanhof",
    image: hamburgstationImg,
    address: "Sylvesterallee 10, Hamburg, Germany",
    link: "https://www.hamburg.com/visitors/getting-here/11874992/hauptbahnhof/",
    date: 14,
    time: "3:12pm",
    day: "Tuesday",
  },
  {
    id: 141530,
    name: "Check-In Hampton Inn Hamburg",
    place: "Hampton Inn - Hamburg City Centre",
    city: "Hamburg",
    image: hamptonImg,
    address: "Nordkanalstrasse 18, Hamburg, 20097, Germany",
    link: "https://www.hilton.com/en/hotels/hamhxhx-hampton-hamburg-city-centre/",
    date: 14,
    time: "3:30pm",
    day: "Tuesday",
  },
  {
    id: 142000,
    name: "Alanis Morissette: Jagged Little Pill Tour",
    place: "Barclay's Arena",
    city: "Hamburg",
    image: alanisImg,
    address: "Sylvesterallee 10, Hamburg, Germany",
    link: "https://alanis.com/events",
    date: 14,
    time: "8:00pm",
    day: "Tuesday",
  },
  {
    id: 151000,
    name: "Caspar David Friedrich et al",
    place: "Hamburger Kunsthalle",
    city: "Hamburg",
    image: hamburgerImg,
    address: "Glockengießerwall 5, 20095 Hamburg, Germany",
    link: "https://www.hamburger-kunsthalle.de/",
    date: 15,
    description: "We need more decor for our house.",
    time: "10:00am",
    day: "Wednesday",
  },
  {
    id: 160900,
    name: "BrandenburgTor und Tiergarten",
    place: "City Centre",
    city: "Berlin",
    image: gayBerlinImg,
    address: "Pariser Platz, Berlin, Germany",
    link: "https://www.nationalcar.com/en/car-rental/locations/de/hamburg-airport-g5n2.html?gclid=CjwKCAjwyryUBhBSEiwAGN5OCCjcbuDAe0cXDaV8z9ujiDvXw368kO6mNZalgz5Z1RhuNJKaRHIB1hoC5eYQAvD_BwE&mcid=paidsearch:35877485&targetid=kwd-349755280534&ef_id=CjwKCAjwyryUBhBSEiwAGN5OCCjcbuDAe0cXDaV8z9ujiDvXw368kO6mNZalgz5Z1RhuNJKaRHIB1hoC5eYQAvD_BwE:G:s&s_kwcid=AL!4824!3!375797825956!e!!g!!national%20car%20rental%20hamburg%20airport!2086457681!72113517810&campaignid=2086457681&gclsrc=aw.ds",
    date: 16,
    description: "Explore BrandenburgTor and Tiergarten",
    time: "9:00am",
    day: "Thursday",
  },
  {
    id: 151200,
    name: "Pick Up a BMW",
    place: "Hamburg International Airport",
    city: "Hamburg",
    image: autobahnImg,
    address: "Flughafenstr. 1 3, 22335 Hamburg, Germany",
    link: "https://www.nationalcar.com/en/car-rental/locations/de/hamburg-airport-g5n2.html?gclid=CjwKCAjwyryUBhBSEiwAGN5OCCjcbuDAe0cXDaV8z9ujiDvXw368kO6mNZalgz5Z1RhuNJKaRHIB1hoC5eYQAvD_BwE&mcid=paidsearch:35877485&targetid=kwd-349755280534&ef_id=CjwKCAjwyryUBhBSEiwAGN5OCCjcbuDAe0cXDaV8z9ujiDvXw368kO6mNZalgz5Z1RhuNJKaRHIB1hoC5eYQAvD_BwE:G:s&s_kwcid=AL!4824!3!375797825956!e!!g!!national%20car%20rental%20hamburg%20airport!2086457681!72113517810&campaignid=2086457681&gclsrc=aw.ds",
    date: 15,
    description: "Spend the day on the Autobahn.",
    time: "12:00pm",
    day: "Wednesday",
  },
  {
    id: 161200,
    link: "https://www.nationalcar.com/en/car-rental/locations/de/berlin-brandenburg-airport-g5n3.html",
    name: "Return the BMW",
    place: "Berlin-Brandenburg International Airport",
    city: "Berlin",
    image: autobahnImg,
    address: "12529 Schonefeld, Brandenburg, Germany",
    date: 16,
    description: "Return the BMW.",
    time: "12:00pm",
    day: "Thursday",
  },
  {
    id: 171500,
    name: "Check In - Hotel Luc",
    place: "Hotel Luc",
    city: "Berlin",
    image: lucImg,
    address: "Charlottenstraße 50, 10117 Berlin, Germany",
    link: "https://www.hamburger-kunsthalle.de/",
    date: 17,
    description: "Autograph Collection",
    time: "3:00pm",
    day: "Friday",
    confirmation: "Confirmation: 86921880",
  },
  {
    id: 171200,
    name: "Ritter Workshop",
    place: "Ritter HQ",
    city: "Berlin",
    image: ritterImg,
    address:
      "Ritter Sport Bunte Schokowelt, Französische Straße 24, 10117 Berlin",
    link: "https://www.ritter-sport.com/berlin",
    date: 17,
    description: "Make your own chocolate. This is a gift from Victoria.",
    time: "12:00pm",
    day: "Friday",
    confirmation: "Confirmation: BB20220520227002",
  },
  {
    id: 172100,
    name: "Italorama Bar / Panorama",
    place: "Berghain",
    city: "Berlin",
    image: berghainImg,
    address: "Am Wriezener Bahnhof, 10243 Berlin, Germany",
    link: "https://www.berghain.berlin/en/event/73160/",
    date: 17,
    description:
      "Like Giorgio on the radio at midnight, only on top of the world.",
    time: "9:00pm",
    day: "Friday",
    confirmation: "",
  },
  {
    id: 182000,
    name: "Base Flying in Berlin",
    city: "Berlin",
    place: "Park Inn Hotel, Alexanderplatz",
    image: baseImg,
    address: "Park Inn Hotel, Alexanderplatz 7, 10178 Berlin, Germany",
    link: "https://www.base-flying.de/",
    description:
      "This is where you jump off a skyscraper. Because what else could compare to falling out a plane towards Paradise?",
    date: 18,
    time: "8:00pm",
    day: "Saturday",
    confirmation: "Confirmation: 2051833081",
  },
  {
    id: 151500,
    name: "Check In - Hilton Berlin",
    city: "Berlin",
    place: "Hilton Berlin",
    image: hiltonImg,
    time: "3:00pm",
    address: "Mohrenstraße 30, 10117 Berlin, Germany",
    day: "Wednesday",
    date: 15,
    description: "Check In at the Hilton Berlin",
    confirmation: "Confirmation: 3254552011",
    link: "https://www.hilton.com/en/hotels/berhitw-hilton-berlin/?SEO_id=GMB-EMEA-TW-BERHITW",
  },
  {
    id: 181000,
    name: "Museumsinsel",
    city: "Berlin",
    place: "Museumsinsel",
    image: antinoosImg,
    date: 18,
    time: "11:00am",
    address: "Museum Island, Berlin, Germany",
    day: "Saturday",
    description: "Explore Museum Island",
    link: "https://www.smb.museum/en/museums-institutions/altes-museum/home/",
  },
  {
    id: 191200,
    name: "Depart Frankfurt Airport",
    city: "Berlin",
    place: "Frankfurt International Airport",
    image: lufthansaImg,
    time: "11:00am",
    date: 19,
    address: "60547 Frankfurt, Germany",
    day: "Sunday",
    description: "Depart Frankfurt Airport",
    link: "https://www.frankfurt-airport.com/en.html",
  }
  
];
